export const theme = {
  color: {
    fundoorBlue: '#00A0E2',
    adminPrimary: '#20a8d8',
    azure: '#00a6e0',
    turtleGreen: '#70b559',
    warmGrey: '#838383',
    warmGreyTwo: '#959595',
    warmGreyThree: '#747474',
    warmGreyFour: '#818181',
    warmGreyFive: '#9b9b9b',
    warmGreySix: '#979797',
    grey: '#333',
    greyish: '#b6b6b6',
    greyishTwo: '#aaaaaa',
    greyishThree: '#b5b5b5',
    greyishFour: '#8ca0b4',
    greyishBrown: '#555555',
    greyishBrownTwo: '#4c4c4c',
    greyishBrownThree: '#3e3e3e',
    greyishBrownFour: '#4a4a4a',
    greyBorder: '#d1d0d1',
    supplementaryTextGray: '#bdbdbd',
    supplementaryLineGray: '#ebebeb',
    navy: '#002036',
    alto: '#dcdcdc',
    altoTwo: '#d9d9d9',
    brownishGrey: '#686868',
    white: '#ffffff',
    whiteTwo: '#f5f5f5',
    whiteThree: '#d2d2d2',
    whiteFour: '#f6f6f6',
    whiteFive: '#d8d8d8',
    whiteSix: '#ededed',
    pinkishGrey: '#bfbfbf',
    pinkishGreyTwo: '#d0d0d0',
    pinkishGreyThree: '#c4c4c4',
    rustyRed: '#ba1717',
    errorRed: '#ff253a',
    darkSkyBlue: '#2ba3d5',
    brick: '#a81d1d',
    marineBlue: '#00416d',
    midBlue: '#2b69a3',
    paleBlue: '#d9edfd',
    skyBlue: '#46bafd',
    lightSkyBlue: '#cde9ff',
    paleGrey: '#f9f9fa',
    paleGreyTwo: '#f8fafc',
    orange: '#db8800',
    regalBlue: '#00416d',
    prussianBlue: '#002e4d',
    blueGray: '#14283c',
    blueGrayActive: '#343434',
    blueGraySelected: '#4d7399',
    blueGrayRequired: '#263b4e',
    blueCyan: '#0f90bf',
    blue: '#38a4f8',
    blueTwo: '#3393d3',
    companyHeader: '#343434',
    grayLine: '#ffffff1f',
    grayTableInput: '#eef0f2',
    grayBorder: '#ededed',
    doveGray: '#666666',
    apple: '#4AB043',
    slate: '#343434',
    darkBlueGrey: '#14283c',
    concrete: '#f2f2f2',
    blueForm: '#6699fe',
    blueFormRight: '#f8fafc',
    blueOptional: '#263b4e',
    monza: '#d0021b',
    grayPassword: '#eef0f2',
    grayStockButton: '#eceef0',
    grayStockBorder: '#e2e4e6',
    grayStockText: '#242a5e',
    waterBlue: '#0f90bf',
    darkGreyBlue: '#343434',
    grayIcon: '#b4bec8',
    grayLineBottom: '#e8e8e8',
    grayOption: '#676767',
    grayThumb: '#dfdfdf',
    grayTextThumb: '#7e7e7e',
    colorOne: '#ff4647',
    colorTwo: '#f5a623',
    grayTable: '#f9f9f9',
    blueDot: '#c8d2dc',
    ripeLemon: '#f8e71c',
    lineSetting: '#dedede',
    lochmara: '#0082cb',
    rhino: 'rgba(40, 60, 80, 0.24)',
    rhinoTwo: '#253b4e',
    rhinoThree: '#253851',
    pickledBluewood: 'rgba(40, 60, 80, 0.12)',
    pickledBluewoodTwo: '#283B50',
    eucalyptus: '#23a25a',
    lilyWhite: '#ecfaff',
    punch: '#da4733',
    royalBlue: '#3b78e7',
    mySin: '#fdba2c',
    black: '#000000',
    puertoRico: '#4AC9C9',
    pictonBlue: '#3fa9f5',
    cardinal: '#bf2221',
    darkgray: '#4f4f4f',
    gray200: '#ececec',
    transparentFundoorBlue: 'rgba(0, 160, 226, 0.15)',
    textGray: '#939393',
  },
  screen: {
    xs: '480px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
  },
};

export const PIE_CHART_COLORS = [
  '#003399',
  '#004FBE',
  '#0078CC',
  '#00A0E2',
  '#6FD0F4',
  '#95E6FF',
  '#BAF2FF',
  '#D9F9FF',
  '#DDDDDD',
  '#C0C0C0',
];

export const { color, screen } = theme;
